/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';

import Input from './Input';

interface Props {
  checked: boolean;
  disabled?: boolean;
  field: any;
  id?: string;
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  value: any;
}

/**
 * @deprecated
 * Please see the inputs in the ui folder of your project
 */
export default class RadioButton extends React.PureComponent<Props> {
  render() {
    return <Input classNames="RadioButton-input" type="radio" {...this.props} />;
  }
}
